export default function ButtonCancel({ hide = false, onClick = () => {}, disabled = false, children }) {
    return (
        <div className={`state-pages__navgiation state-pages__cancel ${disabled ? 'state-pages__navgiation--disabled' : ''} ${hide ? 'state-pages__navgiation--hidden' : ''}`} onClick={hide ? () => {} : onClick}>
            <p>{ children }</p> <img src="/assets/cancel.svg" />
        </div>
    )
}
